interface PostSlug {
  [key: string]: string; // key is language code, value is slug
}
// Define path translations between all languages
const pathTranslations = {
  // German paths
  "/uber-uns/": {
    de: "/uber-uns/",
    en: "/about-us/",
    ro: "/despre-noi/",
  },
  "/hilfecenter/": {
    de: "/hilfecenter/",
    en: "/help-center/",
    ro: "/centrul-de-ajutor/",
  },
  "/unternehmensdienstleistungen/": {
    de: "/unternehmensdienstleistungen/",
    en: "/company-services/",
    ro: "/servicii-companie/",
  },
  "/unternehmenspfleger/": {
    de: "/unternehmenspfleger/",
    en: "/company-caregivers/",
    ro: "/îngrijitori-companie/",
  },
  "/gesellschaftliche-auswirkungen-unternehmen/": {
    de: "/gesellschaftliche-auswirkungen-unternehmen/",
    en: "/company-social-impact/",
    ro: "/impact-social-companie/",
  },
  "/pflegkrafte-24h/": {
    de: "/pflegkrafte-24h/",
    en: "/caregiver-24h/",
    ro: "/Îngrijitori-24h/",
  },
  "/pflegkrafte-normale/": {
    de: "/pflegkrafte-normale/",
    en: "/caregiver-normal/",
    ro: "/Îngrijitori-normali/",
  },
  "/pflegebedürftigen-24h/": {
    de: "/pflegebedürftigen-24h/",
    en: "/careseeker-24h/",
    ro: "/îngrijire-24h/",
  },
  "/pflegebedürftigen-normale/": {
    de: "/pflegebedürftigen-normale/",
    en: "/careseeker-normal/",
    ro: "/îngrijire-normali/",
  },
  "/pflegkrafte-service/": {
    de: "/pflegkrafte-service/",
    en: "/caregiver-services/",
    ro: "/Îngrijitori-servicii/",
  },
  "/pflegebedürftigen-service/": {
    de: "/pflegebedürftigen-service/",
    en: "/careseeker-services/",
    ro: "/îngrijire-servicii/",
  },
  "/blog/": {
    de: "/blog/",
    en: "/blog/",
    ro: "/blog/",
  },
  "/karriere/": {
    de: "/karriere/",
    en: "/career/",
    ro: "/cariera/",
  },

  // English paths
  "/about-us/": {
    de: "/uber-uns/",
    en: "/about-us/",
    ro: "/despre-noi/",
  },
  "/help-center/": {
    de: "/hilfecenter/",
    en: "/help-center/",
    ro: "/centrul-de-ajutor/",
  },
  "/company-services/": {
    de: "/unternehmensdienstleistungen/",
    en: "/company-services/",
    ro: "/servicii-companie/",
  },
  "/company-caregivers/": {
    de: "/unternehmenspfleger/",
    en: "/company-caregivers/",
    ro: "/îngrijitori-companie/",
  },
  "/company-social-impact/": {
    de: "/gesellschaftliche-auswirkungen-unternehmen/",
    en: "/company-social-impact/",
    ro: "/impact-social-companie/",
  },
  "/caregiver-24h/": {
    de: "/pflegkrafte-24h/",
    en: "/caregiver-24h/",
    ro: "/Îngrijitori-24h/",
  },
  "/caregiver-normal/": {
    de: "/pflegkrafte-normale/",
    en: "/caregiver-normal/",
    ro: "/Îngrijitori-normali/",
  },
  "/careseeker-24h/": {
    de: "/pflegebedürftigen-24h/",
    en: "/careseeker-24h/",
    ro: "/îngrijire-24h/",
  },
  "/careseeker-normal/": {
    de: "/pflegebedürftigen-normale/",
    en: "/careseeker-normal/",
    ro: "/îngrijire-normali/",
  },
  "/caregiver-services/": {
    de: "/pflegkrafte-service/",
    en: "/caregiver-services/",
    ro: "/Îngrijitori-servicii/",
  },
  "/careseeker-services/": {
    de: "/pflegebedürftigen-service/",
    en: "/careseeker-services/",
    ro: "/îngrijire-servicii/",
  },
  "/career/": {
    de: "/karriere/",
    en: "/career/",
    ro: "/cariera/",
  },

  // Romanian paths
  "/despre-noi/": {
    de: "/uber-uns/",
    en: "/about-us/",
    ro: "/despre-noi/",
  },
  "/centrul-de-ajutor/": {
    de: "/hilfecenter/",
    en: "/help-center/",
    ro: "/centrul-de-ajutor/",
  },
  "/servicii-companie/": {
    de: "/unternehmensdienstleistungen/",
    en: "/company-services/",
    ro: "/servicii-companie/",
  },
  "/îngrijitori-companie/": {
    de: "/unternehmenspfleger/",
    en: "/company-caregivers/",
    ro: "/îngrijitori-companie/",
  },
  "/impact-social-companie/": {
    de: "/gesellschaftliche-auswirkungen-unternehmen/",
    en: "/company-social-impact/",
    ro: "/impact-social-companie/",
  },
  "/Îngrijitori-24h/": {
    de: "/pflegkrafte-24h/",
    en: "/caregiver-24h/",
    ro: "/Îngrijitori-24h/",
  },
  "/Îngrijitori-normali/": {
    de: "/pflegkrafte-normale/",
    en: "/caregiver-normal/",
    ro: "/Îngrijitori-normali/",
  },
  "/îngrijire-24h/": {
    de: "/pflegebedürftigen-24h/",
    en: "/careseeker-24h/",
    ro: "/îngrijire-24h/",
  },
  "/îngrijire-normali/": {
    de: "/pflegebedürftigen-normale/",
    en: "/careseeker-normal/",
    ro: "/îngrijire-normali/",
  },
  "/Îngrijitori-servicii/": {
    de: "/pflegkrafte-service/",
    en: "/caregiver-services/",
    ro: "/Îngrijitori-servicii/",
  },
  "/îngrijire-servicii/": {
    de: "/pflegebedürftigen-service/",
    en: "/careseeker-services/",
    ro: "/îngrijire-servicii/",
  },
  "/cariera/": {
    de: "/karriere/",
    en: "/career/",
    ro: "/cariera/",
  },
};

export const getLanguageAlternatives = (currentPath: string) => {
  // Remove trailing slash for consistency
  let path = currentPath.replace(/\/$/, "") + "/"; // Add trailing slash for matching

  // If it's the homepage
  if (path === "/") {
    return [
      { lang: "de", path: "/", isDefault: true },
      { lang: "en", path: "/en", isDefault: false },
      { lang: "ro", path: "/ro", isDefault: false },
    ];
  }

  // Remove locale prefix if it exists
  let pathWithoutLocale = path;
  let currentLocale = "de"; // default

  if (path.startsWith("/en/")) {
    pathWithoutLocale = path.replace("/en", "");
    currentLocale = "en";
  } else if (path.startsWith("/ro/")) {
    pathWithoutLocale = path.replace("/ro", "");
    currentLocale = "ro";
  }

  // Find translations for this path
  let translations = pathTranslations[pathWithoutLocale];

  // If not found, try to find it as a translation in other entries
  if (!translations) {
    for (const [originalPath, trans] of Object.entries(pathTranslations)) {
      if (pathWithoutLocale === trans[currentLocale]) {
        translations = trans;
        break;
      }
    }
  }

  // If still no translations found, use original path for all
  if (!translations) {
    translations = {
      de: pathWithoutLocale,
      en: pathWithoutLocale,
      ro: pathWithoutLocale,
    };
  }

  // Generate alternatives
  return [
    { lang: "de", path: translations.de?.replace(/\/$/, ""), isDefault: true },
    {
      lang: "en",
      path: "/en" + translations.en?.replace(/\/$/, ""),
      isDefault: false,
    },
    {
      lang: "ro",
      path: "/ro" + translations.ro?.replace(/\/$/, ""),
      isDefault: false,
    },
  ];
};

export const getPostLanguageAlternatives = (
  currentPath: string,
  postSlug?: PostSlug
) => {
  // Remove trailing slash for consistency
  let path = currentPath.replace(/\/$/, "") + "/";

  // If it's a blog post (postSlug is provided)
  if (postSlug) {
    return [
      {
        lang: "de",
        path: `/blog/${postSlug.de}`.replace(/\/$/, ""),
        isDefault: true,
      },
      {
        lang: "en",
        path: `/en/blog/${postSlug.en}`.replace(/\/$/, ""),
        isDefault: false,
      },
      {
        lang: "ro",
        path: `/ro/blog/${postSlug.ro}`.replace(/\/$/, ""),
        isDefault: false,
      },
    ];
  }
};
